module.exports = __webpack_public_path__ + "static/img/new-home-x.b4937ba6.jpg";